<!--
 * @Author: guang
 * @Date: 2020-12-16 15:53:59
 * @LastEditTime: 2020-12-16 15:55:01
 * @LastEditors: guang
 * @Description:
-->
<template>
  <div class="chunhui-share-page ignore">
    <!-- 二维码区域 -->
    <div class="bottom-area">
      <!-- 二维码图片 -->
      <div class="qr-code p-abs">
        <img v-if="isIOS" src="~@/assets/imgs/share/chunhui/qrCode_iOS@2x.png" alt="二维码">
        <img v-else src="~@/assets/imgs/share/chunhui/qrCode_Android@2x.png" alt="二维码">
      </div>
      <!-- 点击按钮 -->
      <div class="handle-button p-abs" @click="handleButtonClick">
        <img v-if="isIOS" src="~@/assets/imgs/share/chunhui/iOS@2x.png" alt="按钮">
        <img v-else src="~@/assets/imgs/share/chunhui/Android@2x.png" alt="按钮">
      </div>

    </div>

  </div>
</template>

<script>
// utils
import utils from '@/utils/utils'

const { isIOS, transformLocationHref } = utils

export default {
  name: 'chunhui-share-page',
  components: {},
  props: {},
  data() {
    return {
      isIOS
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 点击按钮跳转
    handleButtonClick () {
      const linkIOS = 'https://itunes.apple.com/cn/app/id1493761859'
      const linkAND = 'http://wg.cloud.ininin.com/7eaa886ca09d4cc72f771a118298f8d7?download=zhiban.apk'
      const link = this.isIOS ? linkIOS : linkAND
      return transformLocationHref(link)
    }
  },
  filters: {},
  created () {},
  mounted () {}
}
</script>

<style lang='less' scoped>
@viewRate: 3.75;
.ignore.chunhui-share-page {
  height: 667vw / @viewRate;
  background: url("~@/assets/imgs/share/chunhui/bg@2x.png");
  background-size: contain;
  .bottom-area {
    position: relative;
    padding-top: 480vw / @viewRate;
    height: 187vw / @viewRate;
    .p-abs {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      img {
        width: 100%;
      }
    }
    .qr-code {
      padding: 7.5vw / @viewRate;
      width: 65vw / @viewRate;
      height: 65vw / @viewRate;
      top: 500vw / @viewRate;
      background: white;
      border-radius: 3vw / @viewRate;
    }
    .handle-button {
      width: 104vw / @viewRate;
      height: 26vw / @viewRate;
      top: 595vw / @viewRate;
    }
  }
}
</style>
